
import SelectSingle from './select-single';
import SelectMulti from './select-multi';

function select(props) {
  if (props.type === 'multi') {
    return new SelectMulti(props);
  } else {
    return new SelectSingle(props);
  }
}

export default select;


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/select/index.js
// module id = 566
// module chunks = 9